/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod'

export const connectionTestResultLatencyMsOneMin = 0
export const connectionTestResultLatencyMsOneMax = 9007199254740991

export const connectionTestResultTestedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)

export const ConnectionTestResult = zod.object({
  apiReady: zod.boolean(),
  authenticated: zod.boolean(),
  bookingEnabled: zod.boolean().nullable(),
  error: zod.union([
    zod.enum(['timeout', 'connection_refused', 'tls_error', 'unauthorized', 'bad_response', 'pf_not_ready']),
    zod.null(),
  ]),
  keeperVersion: zod.string().nullable(),
  latencyMs: zod.union([
    zod.int().min(connectionTestResultLatencyMsOneMin).max(connectionTestResultLatencyMsOneMax),
    zod.null(),
  ]),
  pfLoggedIn: zod.boolean(),
  pfTimeZone: zod.string().nullable(),
  reachable: zod.boolean(),
  testedAt: zod.iso.datetime({ offset: true }).regex(connectionTestResultTestedAtRegExp),
  timeZoneMatches: zod.boolean().nullable(),
})

export type ConnectionTestResult = zod.input<typeof ConnectionTestResult>
export type ConnectionTestResultOutput = zod.output<typeof ConnectionTestResult>
